import axios from 'axios';

class Drone {
  constructor(profile) {
    this.apiURL = 'http://localhost:3001';
    this.missionRunning = false;
    this.commandQueue = [];
    this.retryCommandCount = 3;
    this.retryCount = 0;
    this.messageQueue = [];
    this.profile = profile;
  }

  getStatus() {
    const self = this;
    return new Promise((resolve, reject) => {
      axios.get(`${this.apiURL}/drone/poll`).then((result) => {
        // console.log('status: ', result.data);
        const messages = {};
        messages.status = result.data.status;
        messages.logs = self.messageQueue;
        // Drone communication logs, so support can read them from the UI
        // without opening the Electron console.
        if (result.data.logs && result.data.logs.length) {
          messages.logs = messages.logs.concat(result.data.logs);
        }
        self.messageQueue = [];
        resolve(messages);
      }).catch((err) => {
        reject(err);
      });
    });
  }

  getWifiList() {
    return new Promise((resolve, reject) => {
      axios.get(`${this.apiURL}/scanWifi`).then((result) => {
        resolve(result);
      }).catch((err) => {
        reject(err);
      });
    });
  }

  setWifi(ssid) {
    return new Promise((resolve, reject) => {
      axios.get(`${this.apiURL}/setWifi/${ssid}/${this.profile}`).then((result) => {
        resolve(result);
      }).catch((err) => {
        reject(err);
      });
    });
  }

  setSSID(newSSID) {
    return new Promise((resolve, reject) => {
      axios.get(`${this.apiURL}/drone/changeSSID/${newSSID.trim()}`).then((result) => {
        resolve(result);
      }).catch((err) => {
        reject(err);
      });
    });
  }


  parseBlocklyCommands(commandString) {
    const mission = eval(commandString); /* eslint-disable-line */
    const commands = mission.split('|');
    commands.unshift('command');

    let land = false;
    for (let i = 0; i < commands.length; i += 1) {
      commands[i] = commands[i].replace(/,null/g, '').replace(/,/g, '_');
      if (commands[i] === 'land') {
        land = true;
      }
    }
    if (!land) {
      commands.push('land');
    }

    return commands;
  }

  execute(command) {
    return new Promise((resolve, reject) => {
      axios.get(`${this.apiURL}/drone/send/${command}`).then((result) => {
        if (result.data.slice(0, 2) === 'Re') {
          resolve(result.data.slice(7));
        } else if (result.data === 'ok') {
          resolve(result.data);
        } else {
          reject(result.data);
        }
      }).catch((err) => {
        reject(err);
      });
    });
  }

  executeQueue() {
    if (this.commandQueue.length <= 0) {
      this.missionRunning = false;
      this.messageQueue.push('Vuelo terminado.');
      return;
    }

    const command = this.commandQueue.shift();
    this.messageQueue.push(`Comando: ${command}`);
    this.execute(command).then((resp) => {
      console.log('sent:', resp, command);
      this.messageQueue.push(`${resp}`);
      this.retryCount = this.retryCommandCount;
      this.executeQueue();
    }).catch((err) => {
      this.retryCount -= 1;
      console.log('sent error:', command, err, this.retryCount);
      this.messageQueue.push(this.describeDroneError(command, err));
      if (this.retryCount > 0) {
        this.commandQueue.unshift(command);
        this.executeQueue();
      } else {
        // The counter used to be reset here and the mission carried on, so the
        // drone kept flying the plan while ignoring errors.
        this.abortMission(command, err);
      }
    });
  }

  // Turns the raw drone reply into something readable in the console. A bare
  // `error` means the drone refused because of low battery; real failures
  // carry text after it.
  describeDroneError(command, err) {
    // A timeout arrives as HTTP 500 with its text in `response.data`, while a
    // drone rejection arrives as a plain string.
    let raw = err;
    if (typeof raw !== 'string') {
      raw = (err && err.response && err.response.data)
        || (err && err.message)
        || err;
    }
    raw = String(raw).trim();
    const texto = raw.toLowerCase();

    if (texto === 'error') {
      return `Batería insuficiente: el dron no pudo hacer "${command}".`;
    }
    if (texto.indexOf('auto land') !== -1) {
      return 'El dron se quedó sin batería y aterrizó solo.';
    }
    if (texto.indexOf('motor stop') !== -1) {
      return `El dron tiene los motores detenidos, no puede hacer "${command}".`;
    }
    if (texto.indexOf('take off first') !== -1) {
      return `El dron todavía no despegó, no puede hacer "${command}".`;
    }
    if (texto.indexOf('no valid imu') !== -1) {
      return `El dron no está estabilizado, no puede hacer "${command}".`;
    }
    if (texto.indexOf('límite de espera') !== -1 || texto.indexOf('limite de espera') !== -1) {
      return `El dron no respondió a "${command}". Puede haberse perdido la conexión.`;
    }
    return `Error en "${command}": ${raw}`;
  }

  // Stops the mission and lands the drone when a command ran out of retries.
  abortMission(failedCommand, lastError) {
    this.commandQueue = [];
    this.retryCount = this.retryCommandCount;

    const crudo = (typeof lastError === 'string') ? lastError.trim().toLowerCase() : '';
    if (crudo === 'error' || crudo.indexOf('auto land') !== -1) {
      this.messageQueue.push('Misión detenida: el dron no tiene batería suficiente para continuar.');
    } else {
      this.messageQueue.push(`Misión detenida: "${failedCommand}" falló ${this.retryCommandCount} veces.`);
    }

    // Retrying here when landing itself failed would be a loop.
    if (failedCommand.indexOf('land') !== -1) {
      this.missionRunning = false;
      this.messageQueue.push('El aterrizaje no respondió. Revisá el dron.');
      return;
    }

    this.messageQueue.push('Aterrizando por seguridad ...');
    const finalizar = () => {
      this.missionRunning = false;
    };
    this.execute('land').then(() => {
      this.messageQueue.push('Dron aterrizado.');
      finalizar();
    }).catch((err) => {
      console.log('land error on abort:', err);
      this.messageQueue.push('No se pudo confirmar el aterrizaje. Revisá el dron.');
      finalizar();
    });
  }

  checkBatteryCommands(commandString) {
    return new Promise((resolve, reject) => {
      if (commandString.indexOf('flip') === -1) {
        resolve(true);
        return;
      }
      this.getStatus().then((result) => {
        const hasReading = result.status && typeof result.status.bat !== 'undefined';
        // Telemetry comes from port 8890, which is often blocked. Without a
        // reading we cannot claim the battery is low: warning here fired on
        // every mission with flips, even with a full charge.
        if (!hasReading) {
          resolve(true);
          return;
        }
        resolve(Number(result.status.bat) >= 50);
      }).catch((err) => {
        reject(err);
      });
    });
  }

  executeCommands(commandString) {
    this.commandQueue = this.parseBlocklyCommands(commandString);

    this.retryCount = this.retryCommandCount;
    this.missionRunning = true;
    this.executeQueue();
    this.messageQueue.push('Comenzando el vuelo ...');
    console.log('Starting mission with: ', this.commandQueue);
  }
}

export default Drone;
